import { render } from "./UserDataSelection.vue?vue&type=template&id=0982b7fa&scoped=true"
import script from "./UserDataSelection.vue?vue&type=script&lang=js"
export * from "./UserDataSelection.vue?vue&type=script&lang=js"

import "./UserDataSelection.vue?vue&type=style&index=0&id=0982b7fa&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0982b7fa"]])

export default __exports__